import React from 'react';
import { Link } from 'react-router-dom';
import { ALL_NUVOLA_COLUMNS, FOOTER_COLUMNS } from './siteNav';

const LinkColumn = ({ column }) => (
  <div>
    <h3 className="text-base font-bold text-black md:text-lg">{column.heading}</h3>
    {/* On phones these were 18px-tall targets on an 8px pitch -- too tight to
        hit reliably. The padding gives each link a ~40px touch area; desktop
        keeps the compact sitemap. */}
    <ul className="mt-2 space-y-1.5">
      {column.links.map((link) => (
        <li key={link.label}>
          <Link
            to={link.to}
            className="inline-block py-2 text-[15px] leading-tight text-black hover:underline md:py-0 md:text-base"
          >
            {link.label}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

const SiteFooter = () => (
  <footer className="w-full bg-white text-black">
    <div className="mx-auto w-full max-w-[1400px] px-6 md:px-10">
      <div className="h-px w-full bg-black/15" />

      {/* Mission statement */}
      <div className="flex flex-col items-center gap-6 py-10 md:flex-row md:gap-10 md:py-14">
        <img
          src="/images/site/home/footer-lightbulb.png"
          alt=""
          aria-hidden="true"
          className="h-[150px] w-auto flex-shrink-0 md:h-[220px]"
        />
        <p className="text-center text-2xl font-light leading-snug md:text-left md:text-[40px]">
          Robbing online scammers of the incentive, time, place and opportunity
          to abuse people.
        </p>
      </div>

      <div className="h-px w-full bg-black/25" />

      {/* Sitemap */}
      <div className="grid grid-cols-1 gap-x-8 gap-y-10 py-10 sm:grid-cols-3 md:py-14">
        {FOOTER_COLUMNS.map((column) => (
          <LinkColumn key={column.heading} column={column} />
        ))}
        {ALL_NUVOLA_COLUMNS.map((column) => (
          <LinkColumn key={column.heading} column={column} />
        ))}
      </div>

      <div className="h-px w-full bg-black/60" />

      {/* Legal bar */}
      <div className="flex flex-col items-center gap-4 py-6 text-sm md:flex-row md:gap-16">
        <p>Copyright &copy; 2025 NuVola AI. All rights reserved</p>
      </div>
    </div>
  </footer>
);

export default SiteFooter;
